import { Link } from "react-router-dom";
import { Bell, ChevronDown, Cookie, Shield } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useUiStore } from "@/stores/ui";
import { isNotificationSupported } from "@/lib/notifications";

export function CookieBanner() {
  const {
    cookieConsent,
    acceptAllCookies,
    acceptEssentialOnly,
    saveCustomPreferences,
    enableNotifications,
  } = useUiStore();
  const [expanded, setExpanded] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [notifications, setNotifications] = useState(true);

  const notificationsSupported = isNotificationSupported();

  async function handleSaveCustom() {
    saveCustomPreferences(analytics, notifications);
    if (notifications && notificationsSupported) {
      await enableNotifications();
    }
  }

  async function handleAcceptAll() {
    acceptAllCookies();
    // Pedido de notificação no mesmo gesto do usuário (necessário pelos browsers)
    if (notificationsSupported) {
      await enableNotifications();
    }
  }

  return (
    <>
      {cookieConsent === "pending" ? (
        <div
          role="dialog"
          aria-labelledby="cookie-banner-title"
          aria-describedby="cookie-banner-desc"
          className="animate-rise-in fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-3xl rounded-lg border border-brand-outline-variant/60 bg-brand-surface-lowest p-5 shadow-float"
        >
          <div className="flex items-start gap-3">
            <div className="hidden rounded bg-brand-primary/10 p-2 text-brand-primary sm:block">
              <Cookie className="h-5 w-5" />
            </div>
            <div className="min-w-0 flex-1">
              <h2 id="cookie-banner-title" className="font-display text-base font-bold text-brand-ink">
                Privacidade e cookies
              </h2>
              <p id="cookie-banner-desc" className="mt-2 text-sm leading-relaxed text-brand-on-surface-variant">
                Utilizamos cookies essenciais para o funcionamento do site e, com seu consentimento, cookies de
                analise para medir audiencia (Google Analytics / metricas internas). Voce pode optar por receber
                notificacoes do navegador sobre novas materias. Consulte nossa{" "}
                <Link to="/privacidade" className="font-medium text-brand-primary hover:underline">
                  Politica de Privacidade
                </Link>
                .
              </p>

              {expanded ? (
                  <div className="mt-4 space-y-3 overflow-hidden rounded border border-brand-outline-variant/50 p-3">
                    <label className="flex cursor-pointer items-start gap-3 text-sm">
                      <input type="checkbox" checked disabled className="mt-1" />
                      <span>
                        <span className="flex items-center gap-1 font-semibold text-brand-ink">
                          <Shield className="h-4 w-4 text-brand-primary" />
                          Essenciais
                        </span>
                        <span className="block text-brand-on-surface-variant">
                          Necessarios para navegacao, seguranca e preferencias salvas.
                        </span>
                      </span>
                    </label>
                    <label className="flex cursor-pointer items-start gap-3 text-sm">
                      <input
                        type="checkbox"
                        checked={analytics}
                        onChange={(e) => setAnalytics(e.target.checked)}
                        className="mt-1"
                      />
                      <span>
                        <span className="font-semibold text-brand-ink">Analise e desempenho</span>
                        <span className="block text-brand-on-surface-variant">
                          Mede pageviews e origem de trafego para melhorar o portal.
                        </span>
                      </span>
                    </label>
                    {notificationsSupported ? (
                      <label className="flex cursor-pointer items-start gap-3 text-sm">
                        <input
                          type="checkbox"
                          checked={notifications}
                          onChange={(e) => setNotifications(e.target.checked)}
                          className="mt-1"
                        />
                        <span>
                          <span className="flex items-center gap-1 font-semibold text-brand-ink">
                            <Bell className="h-4 w-4 text-brand-primary" />
                            Notificacoes de novidades
                          </span>
                          <span className="block text-brand-on-surface-variant">
                            Alertas no navegador quando publicarmos materias relevantes.
                          </span>
                        </span>
                      </label>
                    ) : null}
                  </div>
                ) : null}

              <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
                <Button onClick={handleAcceptAll} className="rounded">
                  Aceitar todos
                </Button>
                <Button variant="secondary" onClick={acceptEssentialOnly} className="rounded">
                  Apenas essenciais
                </Button>
                <Button
                  variant="ghost"
                  type="button"
                  onClick={() => {
                    if (expanded) {
                      void handleSaveCustom();
                    } else {
                      setExpanded(true);
                    }
                  }}
                  className="rounded"
                >
                  {expanded ? "Salvar preferencias" : "Personalizar"}
                  {!expanded ? <ChevronDown className="h-4 w-4" /> : null}
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
